export default {
  message: {
    message_center: '消息通知',
    send_message: '发送信息',
    send: {
      send_message: {
        success: '发送成功'
      }
    },
    conditions: {
      balance: '余额'
    },
    new_page: {
      label: '发送消息',
      select_user: {
        mobile_phone: '手机',
        selected_users_count: '已选用户',
        os: '安卓/iOS用户',
        other_tips: '其他用户可在消息中心查看',
        announce_tips: '所有用户都可查看通告'
      },
      send_message: {
        message: {
          abstract: '摘要',
          title: '标题',
          content: '内容'
        },
        send: '确认发送',
        confirm: '是否确认发送该信息？',
        sending: '发送中...',
        waiting_tips: '需要调用到第三方的推送功能，发送时间可能会持续1~2分钟，请耐心等候。',
        gift_info: '赠送信息',
        select_discount: '选择优惠',
        add_coupon: '添加优惠券',
        select_charging_card: '选择充电卡',
        add_charging_card: '添加充电卡'
      },
      preview_effect: '预览效果',
      write_content: '填写正文'
    }
  }
}
